/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {};




theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false
};

if (console && console.log) {
  console.log(theme.settings.themeName + ' theme (' + theme.settings.themeVersion + ') by RoarTheme | Learn more at https://roartheme.co');
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

theme.Currency = (function() {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

(function() {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  }

  // Page transition
  document.addEventListener('click', (event) => {

    const anchor = event.target.closest('a');
    if (anchor?.href && /^(mailto:|tel:)/.test(anchor.href)) {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    } else {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    }


  });
  const beforeUnloadHandler = (event) => {
    document.body.classList.add('unloading');
  }
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded');

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading');
    }
  });

  // Viewport height
  let lastViewportHeight = null;
  let viewportHeightQueued = false;
  function viewportHeight() {
    if (viewportHeightQueued) return;
    viewportHeightQueued = true;
    requestAnimationFrame(() => {
      viewportHeightQueued = false;
      const h = window.innerHeight;
      if (window.matchMedia('(max-width: 990px)').matches && h !== lastViewportHeight) {
        lastViewportHeight = h;
        document.documentElement.style.setProperty('--viewport-height', `${h}px`);
      }
      setHeaderBottomPosition();
    });
  }
  window.addEventListener('resize', viewportHeight, { passive: true });
  window.addEventListener('DOMContentLoaded', viewportHeight);

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible');
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' }
    );
    const sections = document.querySelectorAll('.shopify-section + .shopify-section');
    sections.forEach((section) => { observer.observe(section); });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while swiping a flickity slider.
// Listeners live on each slider (not on <body>), so normal page touches/scrolls
// never run this code. They are removed again when the slider is destroyed.
(function() {
  if (typeof Flickity === 'undefined' || !Flickity.create) return;

  Flickity.create.touchScrollGuard = function() {
    var el = this.element;
    var start = null;

    var onStart = function(i) {
      start = { x: i.touches[0].pageX, y: i.touches[0].pageY };
    };
    var onMove = function(i) {
      if (!start || !i.cancelable) return;
      var dx = i.touches[0].pageX - start.x;
      Math.abs(dx) > Flickity.defaults.dragThreshold && i.preventDefault();
    };
    var onEnd = function() { start = null; };

    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onEnd, { passive: true });
    el.addEventListener('touchcancel', onEnd, { passive: true });

    this.on('destroy', function() {
      el.removeEventListener('touchstart', onStart);
      el.removeEventListener('touchmove', onMove);
      el.removeEventListener('touchend', onEnd);
      el.removeEventListener('touchcancel', onEnd);
    });
  };
})();

function isStorageSupported (type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);
  
    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

// function setHeaderBottomPosition() {
//   const header = document.querySelector('.shopify-section-header');
//   if (header) {
//     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
//   }
// }
let lastHeaderBottomPosition = null;
function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    const bottom = header.offsetTop + header.offsetHeight;
    // Only write when it changes: every write restyles the whole page.
    if (bottom === lastHeaderBottomPosition) return;
    lastHeaderBottomPosition = bottom;
    document.documentElement.style.setProperty('--header-bottom-position', `${bottom}px`);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key
    
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

(function() {
  function checkOverflow(root) {
    var slider = root.querySelector('.product-grid.slider');
    var buttonsWrap = root.querySelector('.slider-buttons');
    if (!slider) return;

    // READ phase — wrapped in rAF so it aligns with the browser's natural layout/paint cycle
    requestAnimationFrame(function() {
      var isOverflowing = slider.scrollWidth - slider.clientWidth > 2;

      // WRITE phase (class toggling) happens right after, in the same frame,
      // but since the read already happened, this write won't force another reflow here.
      if (isOverflowing) {
        slider.classList.remove('no-overflow-slider');
        if (buttonsWrap) buttonsWrap.classList.remove('is-hidden-no-overflow');
      } else {
        slider.classList.add('no-overflow-slider');
        if (buttonsWrap) buttonsWrap.classList.add('is-hidden-no-overflow');
      }
    });
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      clearTimeout(timer);
      var args = arguments;
      timer = setTimeout(function() { fn.apply(null, args); }, delay);
    };
  }

  function initAll() {
    document.querySelectorAll('.category-slider-section').forEach(function(section) {
      checkOverflow(section);

      var debouncedCheck = debounce(function() { checkOverflow(section); }, 150);

      // Re-check on resize (debounced) since overflow depends on viewport width
      window.addEventListener('resize', debouncedCheck);

      // Re-check if blocks are added/removed in the theme editor
      // Debounced so rapid mutations don't trigger a read on every single change
      var observer = new MutationObserver(debouncedCheck);
      var slider = section.querySelector('.product-grid.slider');
      if (slider) observer.observe(slider, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-run when section reloads in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.category-slider-section') || event.target;
    if (section && section.classList && section.classList.contains('category-slider-section')) {
      checkOverflow(section);
    }
  });
})();
function pauseAllMedia() {
  document.querySelectorAll('iframe.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('iframe.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('[data-video-hero]')) video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  }
  else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function(path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus?.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus?.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true })));
  }
}
customElements.define('drawer-close-button', DrawerCloseButton);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  setClasses(classes) {
    this.classes = classes;
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.addEventListener('drawer:force-close', (event) => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }

  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
        let mini_cart_test = this.querySelector("mini-cart")
if(document.body.classList.contains(".smart-cart--enabled") && mini_cart_test && Rebuy?.SmartCart) {
  Rebuy.SmartCart.show()
    console.log("smart cart done Object " , Rebuy , Rebuy?.SmartCart?.status)
  return;
}
console.log("rebuy Object" , Rebuy , Rebuy?.SmartCart?.status)

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth();
    setHeaderBottomPosition();

    let mini_cart_test = this.querySelector("mini-cart")
if(document.body.classList.contains("smart-cart--enabled") && mini_cart_test && Rebuy?.SmartCart) {
  Rebuy.SmartCart.show()
    console.log("smart cart done Object " , Rebuy , Rebuy?.SmartCart?.status)
  return;
}
console.log("rebuy Object" , Rebuy , Rebuy?.SmartCart?.status)

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);

    this.openAnimation();
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      removeTrapFocus(elementToFocus);
      
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);
      
      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;
    
    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove('menu-closing');
        }
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing'
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();

    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing'
      });
    }
    else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      });
    }
  }
}
customElements.define('facet-drawer', FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing'
    });
  }
}
customElements.define('header-drawer', HeaderDrawer);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      if (content.querySelector('video-section')) {
        const deferredElement = this.appendChild(content);
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      } else {
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    //this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);


class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll('input,select,textarea');
    this.form = this.querySelector('form');

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this));
      input.addEventListener('blur', this.onInputChange.bind(this));
    });

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid');
        input.classList.add('invalid');
        
        return !1;
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');

        return !0;
      }
    }

    return !0;
  }
}
customElements.define('form-state', FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover = this.closest('menu-drawer').querySelector('list-menu-hover');

    this.addEventListener('mouseenter', () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description
      });
    });
  }
}
customElements.define('list-menu-item', ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = '';
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? '' : ' hover-collection--no-image'}">`;
        html += '<figure class="hover-collection__image"' + (obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : '') + '></figure>';
        html += '<div class="hover-collection__content">'
          html += `<span class="hover-collection__title h4">${obj.title}</span>`;
          html += obj.description.length > 0 ? `<div class="hover-collection__description">${obj.description}</div>` : '';
        html += '</div>';
      html += '</a>';
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = '';
  }
}
customElements.define('list-menu-hover', ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector('.shopify-section-header');

    header.classList.add('transparent-header');
    if (this.dataset.showSeparator == 'true') {
      header.classList.add('transparent-separator');
    }
  }
}
customElements.define('transparent-header', TransparentHeader);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');

  
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler() {
    const variantId = this.dataset.variantId;
    const isUpsell = this.classList.contains("upsell-add-btn");
    if (variantId) {
      if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
        Shopify.postLink(theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1
          },
        });
        return;
      }

      this.setAttribute('disabled', true);
      this.classList.add('loading');
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

      let properties = {};
      let configType = 'javascript';

      if (isUpsell) {
        const upsellprice = this.dataset.itemDiscountPrice;
        if (upsellprice) properties["_discount_price"] = upsellprice;
        configType = 'json';
      }
      const body = JSON.stringify({
         items: [
          {
            id: variantId,
            quantity: 1,
            ...(isUpsell ? { properties } : {}) 
          }
        ],
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig(configType), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
             document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
           }
           else {
            this.miniCart && this.miniCart.renderContents(parsedState);

             document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('loading');
          this.removeAttribute('disabled');
        });
    }
  }
}
customElements.define('add-to-cart', AddToCart);

class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }  

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }
    
    return true;
  }

  init() {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',');
    const symbol = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim();
    const bdi = this.querySelector('bdi');
    const price = bdi.textContent.replace(theme.shopSettings.isoCode,'');
    let html = price.replace(' ', '');
    let money_symbol_decimal = '.';
    if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
      money_symbol_decimal = ',';
    }
    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price_without_symbol.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
      else {
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
    }
    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);
    if(theme.shopSettings.currencyCode){
       html = html + " " + theme.shopSettings.isoCode;
    }
    bdi.innerHTML = html;
  }
}
customElements.define('price-money', PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      small: this.querySelector('.slideshow__left'),
      content: this.querySelector('.slideshow__content'),
      large: this.querySelector('.slideshow__right')
    }
    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll('.slideshow__image'),
      slidesLarge: this.elements.large.querySelectorAll('.slideshow__image')
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: theme.config.mqlSmall ? true : false,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll('.flickity-button');
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute('tabindex', '-1');
              });
            }
          }
        }
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10
      });

      this.bindEvents();
    });
  }

  bindEvents() {
    this.flickitySmall.on('scroll', () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if( 0 === i ) {
            x = Math.abs( flickity.x ) > flickity.slidesWidth ? ( flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flickity.x );
          }
          else if( i === flickity.slides.length - 1 ) {
            x = Math.abs( flickity.x ) + flickity.slides[i].outerWidth < flickity.slidesWidth ? ( slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth ) : ( slide.target + flickity.x );
          }
          else {
            x = slide.target + flickity.x;
          }
          
          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
          }
        }
      });
    });

    this.flickityLarge.on('scroll', () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if( 0 === i ) {
            x = Math.abs( flickity.x ) > flickity.slidesWidth ? ( flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flickity.x );
          }
          else if( i === flickity.slides.length - 1 ) {
            x = Math.abs( flickity.x ) + flickity.slides[i].outerWidth < flickity.slidesWidth ? ( slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth ) : ( slide.target + flickity.x );
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
          }
        }
      });
    });

    this.elements.content.querySelector('.flickity-button.next').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.next();
      this.stopPlayer();
    });

    this.elements.content.querySelector('.flickity-button.previous').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.previous();
      this.stopPlayer();
    });

    this.elements.content.querySelectorAll('.flickity-page-dot').forEach((button) => {
      button.addEventListener('click', () => {
        this.stopPlayer();
      });
    });

    let currentIndex = null,
      swipeDirection = null;
  
    // Detect swipe direction
    this.flickityLarge.on('dragMove',  (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);

      this.stopPlayer();
    });
    
    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on('dragEnd', () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {
        
        if (swipeDirection === 'left') {
          this.flickitySmall.next();
        }
        else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickitySmall && this.flickitySmall.stopPlayer();
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }

  matchMedia() {
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.init();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.init();
    });
  }

  slideTo(index) {
    this.flickityLarge.select(index);
    this.flickityContent.select(index);
    this.flickitySmall.select(index);
  }

  unload() {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === 'function') {
      this.flickitySmall.destroy();
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === 'function') {
      this.flickityContent.destroy();
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === 'function') {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define('slideshow-component', SlideshowComponent);


class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('animate', '');
  }
}
customElements.define('use-animate', UseAnimate);


class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.dataset.accordion === undefined) {
      this.querySelectorAll('.tab-collage__heading').forEach(
        (button) => button.addEventListener('mouseover', this.onButtonClick.bind(this))
      );
    }
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains('is-active')) {
      if (this.dataset.accordion !== undefined) {
        target.classList.remove('is-active');
      }
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll('[data-block-id]').forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add('is-active');
      }
      else {
        button.classList.remove('is-active');
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('tab-collage', TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-countdown');
    this.date = this.parseToDate(this.dataset.date).getTime();
    
    if (isNaN(this.date)) {
      this.unload();
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  parseToDate(input) {
    if (input.includes("T")) {
      return new Date(input);
    }
    
    const [month, day, year] = input.split('-');
    return new Date(`${year}-${month}-${day}`);
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    if (this.dataset.compact == 'true') {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>` : '';
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;
  
      this.innerHTML = dayHTML + otherHTML;
    }
    else {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? theme.dateStrings.day : theme.dateStrings.days}</div>` : '';
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours}</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes}</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds}</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add('hidden');
    if (this.parent) {
      this.parent.classList.add('hidden');
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);


class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = 'beyours:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== 'template';
    this.loop = this.dataset.loop;

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || '.media-wrapper';
    this.parent = this.closest(this.parentSelector);

    switch(this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo();
        break;

      case 'vimeo':
        this.initVimeoVideo();
        break;

      case 'mp4':
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector('video');

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== 'undefined') {
        promise.then(function() {
          // playback normal
        }).catch(function() {
          player.setAttribute('controls', '');
        });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  setAsLoading() {
    this.parent.setAttribute('loading', true);
  }

  setAsLoaded() {
    this.parent.removeAttribute('loading');
    this.parent.setAttribute('loaded', true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;
    
    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div');
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop == '1' ? 1 : 0,
              playlist: videoId,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector('iframe'); // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.mute();
    if (typeof this.player.playVideo === 'function') this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
      });
    }, {rootMargin: '0px 0px 50px 0px'});

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: this.loop == '1' ? true : false,
          playlist: videoId,
          height: '100%',
          width: '100%'
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector('iframe');
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay();
        } else {
          this.vimeoPause();
        }
      });
    }, {rootMargin: '0px 0px 50px 0px'});

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }
}
customElements.define('video-section', VideoSection);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class HeaderMenuToggle extends HTMLElement {
  constructor() {
    super();
    
    this.header = document.querySelector('.shopify-section-header');
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.header.classList.toggle('shopify-section-header-menu-open');
  }
}
customElements.define('header-menu-toggle', HeaderMenuToggle);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);

    if (this.classList.contains('on-header')) {
      document.body.classList.remove('localization--open');
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    // this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    // this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

    if (this.classList.contains('on-header')) {
      document.body.classList.toggle('localization--open');
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class HeaderPopover extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.popoverTarget = this.dataset.target;
    this.popoverEl = document.getElementById(this.popoverTarget);
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.popoverEl.addEventListener('toggle', (e) => {
      console.log('toggle');
      if (this.popoverEl.matches(':popover-open')) {
        this.showPopover();
      } else {
        this.hidePopover();
      }
    });
  }

  showPopover() {
    document.body.classList.add('with-popover');
    //this.popoverEl.showPopover();
  }

  hidePopover() {
    document.body.classList.remove('with-popover');
    //this.popoverEl.hidePopover();
  }
}
customElements.define('header-popover', HeaderPopover);
// onchange upsell variant js 
document.addEventListener("change", function (e) {
  if (!e.target.classList.contains("upsell-variant-select")) return;

  const select = e.target;
  const parent = select.closest(".upsell-item");
  const addBtn = parent.querySelector(".upsell-add-btn");

  const price = select.selectedOptions[0].dataset.price;                 // discounted price
  const originalPrice = select.selectedOptions[0].dataset.originalPrice; // original price
  const comparePrice = select.selectedOptions[0].dataset.compare;        // compare_at_price

  // Update variant ID on Add button
  if (addBtn) {
    addBtn.setAttribute("data-variant-id", select.value);
  }

  // Update price (Discounted or normal)
  const priceBox = parent.querySelector(".upsell-price");
  if (priceBox) {
    priceBox.innerHTML = price;
  }

  // Update compare price (only if valid and discount active)
  const compareBox = parent.querySelector(".upsell-compare-price");

  if (comparePrice && comparePrice !== "$0.00" && comparePrice !== "0" && comparePrice !== originalPrice) {
    // Show compare price
    if (compareBox) {
      compareBox.innerHTML = comparePrice;
    } else {
      const wrapper = parent.querySelector(".upsell-price-wrapper");
      const span = document.createElement("span");
      span.className = "upsell-compare-price";
      span.innerHTML = comparePrice;
      wrapper.prepend(span);
    }
  } else {
    // Remove compare price if no discount
    if (compareBox) compareBox.remove();
  }
});

document.addEventListener("cart:updated", () => {
  const sliders = document.querySelectorAll("upsell-slider-component");

  sliders.forEach(slider => {
    if (slider.flickity) {
      // destroy if already initialized
      slider.flickity.destroy();
    }

    // re-run init()
    slider.init();
  });
});

//  upsell slider 
class UpsellSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.upsell-slider');
     requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.init();
      });
    });
    // theme.initWhenVisible({
    //   element: this,
    //   callback: this.init.bind(this),
    //   threshold: 800
    // });
  }
  init() {
    if (!this.slider) return;

    this.flickity = new Flickity(this.slider, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: true,   
      pageDots: false,
      wrapAround: false,
      draggable: false,       
      cellAlign: 'right',
      freeScroll: true,
      contain: true,
      setGallerySize: true
    });
  }
}

customElements.define('upsell-slider-component', UpsellSliderComponent);

document.addEventListener('product-recommendations:loaded', function (event) {
  const container = event.target;

  // Find sliders inside loaded recommendations
  const sliders = container.querySelectorAll('.upsell-slider');

  sliders.forEach((slider) => {
    if (!slider.classList.contains('slider-initialized')) {
      initUpsellSlider(slider); // your existing slider init function
      slider.classList.add('slider-initialized');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 749) return;

  const interval = setInterval(() => {
    const btn = document.querySelector('.userway_buttons_wrapper');
 

    if (btn) {
      let count = 0;
      let productTemplate = document.body.classList.contains('product--template');

if (productTemplate) {
  btn.style.setProperty('bottom', '20px', 'important');
} else {
  btn.style.setProperty('bottom', '70px', 'important');
}
      const applyStyles = () => {
        btn.style.setProperty('left', '57px', 'important');
        // btn.style.setProperty('bottom', '70px', 'important');
      };

      applyStyles();

      const repeatInterval = setInterval(() => {
        applyStyles();
        count++;

        if (count >= 10) {
          clearInterval(repeatInterval);
        }
      }, 1000);

      clearInterval(interval);
    }
  }, 1000);
});


// Sticky add to cart manage Poistion 

// (function() {
//   function isMobile() {
//     return window.matchMedia('(max-width: 749px)').matches;
//   }

//   function adjustStickyCartPosition() {
//     const stickyCart = document.querySelector('animate-sticky');
//     const stickyTarget = stickyCart?.querySelector('.product-sticky-cart');
//     const headerVisible = document.querySelector('.shopify-body-section-header-sticky:not(.shopify-body-section-header-hidden)');
//     const topMenu = document.querySelector('sticky-header');

//     if (!stickyCart || !stickyTarget) return;

//     if (!isMobile()) {
//       stickyTarget.style.top = '';
//       return;
//     }

//     if (!topMenu) {
//       stickyTarget.style.top = '0px';
//       return;
//     }

//     const topMenuHeight = topMenu.offsetHeight;

//     if (!headerVisible) {
//       // Shopify header hidden — sticky cart sits right below the sticky-header
//       stickyTarget.style.top = '0px';
      
//     } else {
//       // Shopify header still visible — sticky cart at the very top
//       stickyTarget.style.top = topMenuHeight + 'px';
//     }
//   }

//   window.addEventListener('scroll', adjustStickyCartPosition, { passive: true });
//   window.addEventListener('resize', adjustStickyCartPosition);

//   adjustStickyCartPosition();
//   setTimeout(adjustStickyCartPosition, 500);

//   const stickyCartEl = document.querySelector('animate-sticky');
//   if (stickyCartEl) {
//     const observer = new MutationObserver(adjustStickyCartPosition);
//     observer.observe(stickyCartEl, { attributes: true, attributeFilter: ['class', 'hidden', 'animate'] });
//   }

//   const topMenuEl = document.querySelector('sticky-header');
//   if (topMenuEl) {
//     const dockObserver = new MutationObserver(adjustStickyCartPosition);
//     dockObserver.observe(topMenuEl, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
//   }
// })();


// let accessbility__footer__text = document.querySelector(".accessbility__footer__text");
// if(accessbility__footer__text) {
//   accessbility__footer__text.addEventListener("click" ,  function(e) {
//     e.preventDefault();
//     let userwayAccessibilityIcon = document.querySelector("#userwayAccessibilityIcon");
//     if(!userwayAccessibilityIcon) return;
//     userwayAccessibilityIcon.click();
//   })
// }
// (function findUserWayIcon() {
//   let attempts = 0;
//   const maxAttempts = 200;
  
//   // 1. Changed to querySelectorAll to select all instances
//   const accessibilityTexts = document.querySelectorAll(".accessbility__footer__text");

//   const interval = setInterval(() => {
//     attempts++;

//     const el = document.getElementById('userwayAccessibilityIcon');

//     if (el) {
//       clearInterval(interval);
      
//       // 2. Loop through all found elements to update display and classList
//       accessibilityTexts.forEach(btn => {
//         btn.style.display = "flex";
//         btn.classList.remove("visually-hidden"); // Fixed "classlist" typo too!
//       });
      
//       console.log('UserWay icon found after', attempts, 'attempts', el);
//     } else if (attempts >= maxAttempts) {
//       clearInterval(interval);
//       console.warn('UserWay icon not found after', maxAttempts, 'attempts. Giving up.');
//     }
//   }, 200);

//   // 3. Attach the click listener to every matching element in the list
//   accessibilityTexts.forEach(btn => {
//     btn.addEventListener("click", function (e) {
//       e.preventDefault();
//       const userwayAccessibilityIcon = document.querySelector("#userwayAccessibilityIcon");
//       if (!userwayAccessibilityIcon) return;
//       userwayAccessibilityIcon.click();
//     });
//   });
// })();

// (function findUserWayIcon() {
//   let attempts = 0;
//   const maxAttempts = 200;

//   const interval = setInterval(() => {
//     attempts++;

//     // Dono elements ko har interval loop mein dhoondhein taaki race condition na ho
//     const el = document.getElementById('userwayAccessibilityIcon');
//     const accessibilityTexts = document.querySelectorAll(".accessbility__footer__text");

//     if (el && accessibilityTexts.length > 0) {
//       clearInterval(interval);
      
//       // 1. Footer texts ko show karein
//       accessibilityTexts.forEach(btn => {
//         btn.style.setProperty("display", "flex"); // Force flex display
//         btn.classList.remove("visually-hidden");

//         btn.style.cursor = "pointer"; // Yeh line iOS ke click behavior ke liye zaroori hai!
        
//         // Custom attribute toggle jo iOS Safari ko bataye yeh clickable element hai
//         btn.setAttribute("role", "button");
        
//         // 2. Click listener isi time attach karein jab dono elements load ho chuke hain
//         btn.addEventListener("click", function (e) {
//           e.preventDefault();
//           e.stopPropagation(); // Event bubble hone se rokein
//           console.log("btn", btn , window.UserWayWidget , window.userWayInstance)
//           const targetIcon = document.getElementById("userwayAccessibilityIcon");

//           if (window.UserWayWidget && typeof window.UserWayWidget.openAndFocus === 'function') {
//   window.UserWayWidget.openAndFocus();
// } else {
//   // Fallback: agar API abhi load na hui ho toh normal click use karein
//   const targetIcon = document.getElementById("userwayAccessibilityIcon");
//   targetIcon.focus();

//   ['mousedown', 'mouseup', 'click'].forEach(eventType => {
//               const customEvt = new MouseEvent(eventType, {
//                 view: window,
//                 bubbles: true,
//                 cancelable: true,
//                 buttons: 1
//               });
//               targetIcon.dispatchEvent(customEvt);
//             });
// }
//           // if (targetIcon) {
//           //   console.log("targetIcon", targetIcon)
//           //   targetIcon.click();
//           // }
//         });
//       });
      
//       console.log('UserWay icon found and triggers attached after', attempts, 'attempts', el);
//     } else if (attempts >= maxAttempts) {
//       clearInterval(interval);
//       console.warn('UserWay icon or footer texts not found after', maxAttempts, 'attempts.');
//     }
//   }, 200);
// })();


(function relocateAndBindUserWay() {
  let attempts = 0;
  const maxAttempts = 150;

  // Adjust breakpoint to match your theme's actual mobile cutoff if different
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function getSocialParent() {
    return isMobile()
      ? document.querySelector('.mobile__social__icons___moved')
      : document.querySelector('.footer__list-social');
  }

  function applyFixedStyles(movedTarget, realIcon, moveWrapper) {
    moveWrapper.style.setProperty("position", "static", "important");
    moveWrapper.style.setProperty("z-index", "2", "important");
    moveWrapper.style.setProperty("overflow", "visible", "important");

    movedTarget.style.setProperty("position", "static", "important");
    movedTarget.style.setProperty("visibility", "visible", "important");
    movedTarget.style.setProperty("display", "inline-flex", "important");
    movedTarget.style.setProperty("transform", "unset", "important");

    realIcon.style.setProperty("position", "relative", "important");
    realIcon.style.setProperty("visibility", "visible", "important");
    realIcon.style.setProperty("display", "inline-block", "important");
    realIcon.style.setProperty("pointer-events", "auto", "important");
    realIcon.style.setProperty("width", "23px", "important");
    realIcon.style.setProperty("height", "23px", "important");
  }

  function relocate() {
    const realIcon = document.getElementById('userwayAccessibilityIcon') || document.querySelector('div[id*="userway"]');
    const socialParent = getSocialParent();
    const movedTarget = document.querySelector('.userway_buttons_wrapper');

    if (!(realIcon && socialParent && movedTarget)) return false;

    // Ensure ancestors don't clip the widget panel
    let el = socialParent;
    while (el && el !== document.body) {
      const style = getComputedStyle(el);
      if (style.overflow === 'hidden' || style.overflowX === 'hidden') {
        el.style.setProperty('overflow', 'visible', 'important');
      }
      el = el.parentElement;
    }
    movedTarget.style.display ='inline-flex !important'
let img = movedTarget.querySelector(".uiiw img");
if(img) {
   img.setAttribute("alt", "Accessibility Menu");
  img.setAttribute("aria-label", "Open accessibility options");
  img.setAttribute("role", "img");
}
    let moveWrapper = document.querySelector('.userway-moved-parent');

    // If we already relocated for the other breakpoint, rebuild the wrapper
    // in the correct parent for the current breakpoint
    if (moveWrapper && moveWrapper.parentElement !== socialParent) {
      moveWrapper.remove();
      moveWrapper = null;
    }

    if (!moveWrapper) {
      moveWrapper = document.createElement('li');
      moveWrapper.className = isMobile()
        ? 'userway-moved-parent uwy umb userway_p3'
        : 'list-social__item footer__social-item userway-moved-parent uwy umb userway_p3';
      moveWrapper.style.display = 'inline-flex';
      moveWrapper.style.alignItems = 'center';
      socialParent.appendChild(moveWrapper);
    }

    if (movedTarget.parentElement !== moveWrapper) {
      moveWrapper.appendChild(movedTarget);
    }

    applyFixedStyles(movedTarget, realIcon, moveWrapper);
    return true;
  }

  // Initial polling attempt (handles late script/widget load)
  const interval = setInterval(() => {
    attempts++;
    if (relocate()) {
      clearInterval(interval);
      console.log(`UserWay relocated to ${isMobile() ? '.mobile__social__icons___moved (mobile)' : '.footer__list-social (desktop)'}.`);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
      console.warn('Could not locate all targeting elements inside the DOM tree layout.');
    }
  }, 250);

  // Re-relocate on breakpoint change (resize/orientation change)
  let lastIsMobile = isMobile();
  window.addEventListener('resize', () => {
    const nowMobile = isMobile();
    if (nowMobile !== lastIsMobile) {
      lastIsMobile = nowMobile;
      relocate();
    }
  });
})();

(function () {
  let currentSearchQuery = '';

  document.addEventListener('input', function (e) {
    if (
      e.target.matches(
        '.kx-chat-modal input[type="search"], .kx-chat-modal input[type="text"]'
      )
    ) {
      currentSearchQuery = e.target.value;
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      const productCard = e.target.closest('.kx-product-card');

      if (productCard) {
        localStorage.removeItem("location_href");
        sessionStorage.setItem(
          'kx_nav_source',
          JSON.stringify({
            type: 'search',
            query: currentSearchQuery,
            originUrl: window.location.href,
            timestamp: Date.now(),
          })
        );
      }
    },
    true
  );
})();



document.addEventListener('rebuy:smartcart.ready', function () {
  const cartReal = document.body;
  let item_count = window.Rebuy?.Cart.lineCount()
console.log("test____" , item_count, cartReal)
  if (Number(item_count) === 1) {
    cartReal.classList.add("limit_numbers_recomendations")
    cartReal.classList.remove("hide_widget")
  }
  else if (Number(item_count) >= 4) {
    cartReal.classList.add("hide_widget")
    cartReal.classList.remove("limit_numbers_recomendations")
  }
  else {
    cartReal.classList.remove("hide_widget")
    cartReal.classList.remove("limit_numbers_recomendations")
  }
let productCount = window.Rebuy?.Cart.lineCount();
  console.log(productCount , "productCount____")
  if(productCount == 1) {
    document.body.classList.add("increase_1_image")
  }
  else {
    document.body.classList.remove("increase_1_image")
  }

});

document.addEventListener("rebuy:cart.change", (event) => {
  const { cart } = event.detail;
  const shopifyCart = cart.cart;

  console.log("Cart:", shopifyCart);
  console.log("Item count:", shopifyCart.item_count);

  const targetTitle = document.querySelector("#rebuy-cart-title");

  if (shopifyCart.item_count > 0) {
    document.body.classList.remove("rebuy-cart-empty");
  } else {
    document.body.classList.add("rebuy-cart-empty");
  }

  if (targetTitle) {
    // Remove any existing "(n)" from the title
    const baseTitle = targetTitle.innerText.replace(/\s*\(\d+\)\s*$/, "");

    if (shopifyCart.item_count > 0) {
      targetTitle.innerText = `${baseTitle} (${shopifyCart.item_count})`;
    } else {
      targetTitle.innerText = baseTitle;
    }
  }
 
  let productCount = window.Rebuy?.Cart.lineCount();
  console.log(productCount , "productCount____")
  if(productCount == 1) {
    document.body.classList.add("increase_1_image")
  }
  else {
    document.body.classList.remove("increase_1_image")
  }

});

let lastProducts = null;


document.addEventListener('rebuy.productsChange', (event) => {
  const { products, widget } = event.detail;
  if (products === lastProducts) return;
  lastProducts = products;
 console.log("products__updted")
  // Your append logic here

  const interval = setInterval(() => {
    const cart = document.querySelector("#rebuy-cart");
    const crossSells = document.querySelector(
      '[data-rebuy-component="cross-sell-widget"]'
    );

    if (!cart || !crossSells) return;

    const slides = crossSells.querySelectorAll(".rebuy-product-block");

    if (slides.length > 0) {
      clearInterval(interval);

      const isMobile = window.matchMedia("(max-width: 768px)").matches;

      const cartReal = document.body;
let item_count = window.Rebuy?.Cart.lineCount()
  if(Number(item_count) === 1) {
      cartReal.classList.add("limit_numbers_recomendations")
      cartReal.classList.remove("hide_widget")
  }
  else if(Number(item_count) >= 4) {
cartReal.classList.add("hide_widget")

  }
  else {
    cartReal.classList.remove("hide_widget")
    cartReal.classList.remove("limit_numbers_recomendations")
  }

      slides.forEach((slide,index) => {

        const select = slide.querySelector(".rebuy-select");


        // Run on both mobile & desktop
        if (select) {
          console.log("select found")
          select.querySelectorAll("option").forEach((option) => {
            option.textContent = option.textContent.split("/")[0].trim();
          });
        }

        // Mobile only
           if(isMobile && index === 1) {
            
            const title = crossSells.querySelector('.primary-title');
  console.log("title_____" , title)
if (title) {
  title.textContent = "You May Also Like";
}
        }

      });

      // console.log("Slides found:", slides);
    }
  }, 300);


});



document.addEventListener('rebuy:cart.add', (event) => {
  const { cart, item } = event.detail;
  // Your logic here
  console.log("rebuy:cart" , cart)
  if(document.body.classList.contains("smart-cart--enabled") && Rebuy?.SmartCart) {
    Rebuy?.SmartCart?.show();
  }
  else {
      fetch('/?sections=mini-cart,cart-icon-bubble')
    .then(res => res.json())
    .then(sections => {
      const minicart = document.querySelector('mini-cart');
      if (minicart) {
        minicart.open();
        minicart.renderContents({ sections, cart });
  
      }
    });
  //   document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
  //  let cart_2 = document.querySelector("#mini-cart");
  //  if(cart_2) cart_2.open();
  }
});

document.addEventListener('rebuy:smartcart.hide', (event) => {
  let cartContainer = document.querySelector(".cart-drawer-container");
  if(cartContainer) cartContainer.removeAttribute("open")
  console.log('Smart Cart closed');
});


(function () {
  let chatReady = false;
  let pendingOpen = false;
  let isMobile = function () {
    return window.matchMedia('(max-width: 749px)').matches;
  };
if(!isMobile()) return;
  let supportBtn = document.querySelector('.support_dock_item'); // apna actual class/id

  if (supportBtn) {
    supportBtn.addEventListener('click', function () {
      if (!chatReady) {
        pendingOpen = true;
        if (isMobile()) {
          supportBtn.classList.add('loading'); // spinner sirf mobile pe
        }
        return;
      }
      if (window.GorgiasChat.isOpen()) {
        window.GorgiasChat.close();
      } else {
        window.GorgiasChat.open();
      }
    });
  }

  var initGorgiasChatPromise = (window.GorgiasChat)
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', function () {
          resolve();
        });
      });

  initGorgiasChatPromise.then(function () {
    var timer = setInterval(function () {
      var chatButtonIframe = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button');
      if (!chatButtonIframe) return;
      clearInterval(timer);

      chatButtonIframe.style.display = "none";
      chatReady = true;
      supportBtn && supportBtn.classList.remove('loading');

      if (pendingOpen) {
        window.GorgiasChat.open();
        pendingOpen = false;
      }
    }, 50);
  });
  
})();


// function reRunDeliveryDateInjector() {
//   const originalSrc =
//     'https://cdn.shopify.com/extensions/019ed481-e387-76fd-954e-0d74f1d35a63/ultimate-delivery-date-range-21/assets/inject-phrase.js';

//   const script = document.createElement('script');
//   script.type = 'module';
//   // cache-bust so the browser treats it as a *new* module and re-runs top-level code
//   script.src = originalSrc;
//   document.body.appendChild(script);
// }

// // Re-run after Rebuy renders/updates its widgets
// document.addEventListener('rebuy.ready', reRunDeliveryDateInjector);
// document.addEventListener('rebuy:cart.change', reRunDeliveryDateInjector);


(function(){

  class ImagesSlide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._abortController?.abort();
      this._abortController = new AbortController();
      const { signal } = this._abortController;

      this._dots    = this.querySelector('.images_gallery_pagination');
      this._counter = this.querySelector('.counter');
      this._track   = this.querySelector('.slider-track');
      this._arrowL  = this.querySelector('.arrow-left');
      this._arrowR  = this.querySelector('.arrow-right');
      this._slides  = Array.from(this._track.querySelectorAll('.card__media'));
      this._total   = this._slides.length;
      this._current = 0;
      this._dotsArray = [];
      this._maxFull   = 3;
      this._maxSmall  = 1;

      // Dragging state
      this._dragStart     = null;
      this._dragCurrent   = null;
      this._dragging      = false;
      this._dragThreshold = 6; // px of movement before we start treating it as a drag (visual only)

      // NEW: only block the anchor's click when a real slide-changing swipe happened
      this._suppressClick = false;

      if (this._dots) this._dots.innerHTML = '';

      if (this._dots) {
        this._dots.addEventListener('touchmove', (e) => {
          e.preventDefault();
        }, { passive: false });

        this._dots.addEventListener('wheel', (e) => {
          e.preventDefault();
        }, { passive: false });
      }

      this._setupProgressBar();

      this.init();
      this.MobileEvents(signal); // touch drag/swipe — mobile only
      // Desktop intentionally has no drag; navigation is via arrows/keyboard only.

      // NEW: capture-phase click guard on the track.
      // Runs before the <a>'s own navigation, so we can cancel it
      // ONLY when the preceding gesture was an actual slide-changing swipe.
      this._track.addEventListener('click', (e) => {
        if (this._suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
        this._suppressClick = false;
      }, { signal, capture: true });

      this._arrowL.addEventListener('click', () => {
        this.prev();
      }, { signal });

      this._arrowR.addEventListener('click', () => {
        this.next();
      }, { signal });

      this._setupArrowVisibility(signal);
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._dotsArray.forEach((dot) => dot.remove());
      this._dotsArray = [];
    }

    next() {
      if (this._current === this._total - 1) {
        this.goTo(0);
      } else {
        this.goTo(this._current + 1);
      }
    }

    prev() {
      if (this._current === 0) {
        this.goTo(this._total - 1);
      } else {
        this.goTo(this._current - 1);
      }
    }

    // ─────────────────────────────────────────────
    // Always-visible progress bar (real scrollbar feel)
    // ─────────────────────────────────────────────
    _setupProgressBar() {
      if (!document.getElementById('custom-gallery-progress-style')) {
        const style = document.createElement('style');
        style.id = 'custom-gallery-progress-style';
        style.textContent = `
          .custom-gallery-progress-track {
            display: none;
            position: relative;
            width: 100%;
            height: 4px;
            background: ;
            border-radius: 0px;
            overflow: hidden;
            margin: 0;
          }
          .custom-gallery-progress-fill {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            background: rgba(0,0,0,0.55);
            border-radius: 0px;
            display: block !important;
            /* NOTE: no transition while actively dragging — that's what made
               it feel "snappy"/fixed instead of following the drag 1:1.
               We toggle a class to disable transition during drag, see
               _updateProgressBar / drag handlers below. */
            transition: left 0.25s ease, width 0.25s ease;
          }
          .custom-gallery-progress-fill.no-transition {
            transition: none;
          }
          @media (max-width: 749px) {
            .custom-gallery-progress-track {
              display: block;
            }
          }
        `;
        document.head.appendChild(style);
      }

      this._progressTrack = this.querySelector('.custom-gallery-progress-track');
      if (!this._progressTrack) {
        this._progressTrack = document.createElement('div');
        this._progressTrack.className = 'custom-gallery-progress-track';

        this._progressFill = document.createElement('div');
        this._progressFill.className = 'custom-gallery-progress-fill';

        this._progressTrack.appendChild(this._progressFill);

        this._track.insertAdjacentElement('afterend', this._progressTrack);
      } else {
        this._progressFill = this._progressTrack.querySelector('.custom-gallery-progress-fill');
      }

      this._updateProgressBar(0);
    }

    // position can now be FRACTIONAL (e.g. 1.35) so the bar can move
    // smoothly mid-drag, not just snap between whole slide indices.
    _updateProgressBar(position) {
      if (!this._progressFill || !this._progressTrack || !this._total) return;

      const trackWidth = this._progressTrack.offsetWidth || 56;
      const thumbWidth = Math.max(trackWidth / this._total, 14);

      const maxLeft = trackWidth - thumbWidth;
      const clamped = Math.max(0, Math.min(this._total - 1, position));
      const left = this._total > 1
        ? (clamped / (this._total - 1)) * maxLeft
        : 0;

      this._progressFill.style.width = `${thumbWidth}px`;
      this._progressFill.style.left = `${left}px`;
    }

    // ─────────────────────────────────────────────
    // Accessibility
    // ─────────────────────────────────────────────
    _updateSlideAccessibility(current) {
      this._slides.forEach((slide, i) => {
        const focusableEls = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');

        if (i === current) {
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');

          focusableEls.forEach(el => {
            el.setAttribute('tabindex', '0');
          });
        } else {
          slide.setAttribute('inert', '');
          slide.setAttribute('aria-hidden', 'true');

          focusableEls.forEach(el => {
            el.setAttribute('tabindex', '-1');
          });
        }
      });
    }

    // ─────────────────────────────────────────────
    // Arrow visibility
    // ─────────────────────────────────────────────
    _setupArrowVisibility(signal) {
      const isTouchDevice = window.matchMedia('(hover: none)').matches;

      if (isTouchDevice) {
        this._arrowL.classList.add('arrows--visible');
        this._arrowR.classList.add('arrows--visible');
        return;
      }

      this.addEventListener('mouseenter', () => {
        this._arrowL.classList.add('arrows--visible');
        this._arrowR.classList.add('arrows--visible');
      }, { signal });

      this.addEventListener('mouseleave', () => {
        this._arrowL.classList.remove('arrows--visible');
        this._arrowR.classList.remove('arrows--visible');
      }, { signal });

      [this._arrowL, this._arrowR].forEach(arrow => {
        arrow.addEventListener('focus', () => {
          this._arrowL.classList.add('arrows--visible');
          this._arrowR.classList.add('arrows--visible');
        }, { signal });

        arrow.addEventListener('blur', () => {
          if (!this.matches(':hover')) {
            this._arrowL.classList.remove('arrows--visible');
            this._arrowR.classList.remove('arrows--visible');
          }
        }, { signal });
      });
    }

    // ─────────────────────────────────────────────
    // Dots
    // ─────────────────────────────────────────────
    initDots(signal) {
      this._dotsArray = Array.from({ length: this._total }, (_, i) => {
        const d = document.createElement('div');
        d.className = 'image_gallery_dot';
        d.setAttribute('aria-label', `Go to slide ${i + 1}`);
        d.setAttribute('role', 'button');
        d.setAttribute('tabindex', '0');

        d.addEventListener('click', () => {
          this.goTo(i);
        }, { signal });

        d.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.goTo(i);
          }
        }, { signal });

        this._dots.appendChild(d);
        return d;
      });
    }

    _updateDots(current) {
      const total   = this._total;
      const maxFull = this._maxFull;

      if (total <= maxFull) {
        this._dotsArray.forEach((dot, i) => {
          dot.classList.remove('dot--hidden', 'dot--sm', 'dot--xs');
          dot.classList.toggle('active', i === current);
        });
        return;
      }

      let windowStart = current - Math.floor(maxFull / 2);
      windowStart = Math.max(0, windowStart);
      windowStart = Math.min(total - maxFull, windowStart);

      const windowEnd = windowStart + maxFull - 1;

      const roomLeft  = windowStart;
      const roomRight = total - 1 - windowEnd;

      const maxSmallPerSide = 1;
      let leftCount  = Math.min(maxSmallPerSide, roomLeft);
      let rightCount = Math.min(maxSmallPerSide, roomRight);

      const leftSpare  = maxSmallPerSide - leftCount;
      const rightSpare = maxSmallPerSide - rightCount;

      if (leftSpare > 0 && rightCount < roomRight) {
        rightCount = Math.min(roomRight, rightCount + leftSpare);
      }
      if (rightSpare > 0 && leftCount < roomLeft) {
        leftCount = Math.min(roomLeft, leftCount + rightSpare);
      }

      const leftIndices = [];
      for (let k = 1; k <= leftCount; k++) leftIndices.push(windowStart - k);

      const rightIndices = [];
      for (let k = 1; k <= rightCount; k++) rightIndices.push(windowEnd + k);

      this._dotsArray.forEach((dot, i) => {
        dot.classList.remove('active', 'dot--sm', 'dot--xs', 'dot--hidden');

        if (i >= windowStart && i <= windowEnd) {
          dot.classList.toggle('active', i === current);
        } else if (leftIndices.includes(i) || rightIndices.includes(i)) {
          dot.classList.add('dot--sm');
        } else {
          dot.classList.add('dot--hidden');
        }
      });
    }

    _scrollDotsToActive(current) {
      if (!this._dots) return;

      const activeDot = this._dotsArray[current];
      if (!activeDot) return;

      const visibleDots = this._dotsArray.filter(
        d => !d.classList.contains('dot--hidden')
      );

      let dotStep = activeDot.offsetWidth;
      if (visibleDots.length > 1) {
        const r0 = visibleDots[0].getBoundingClientRect();
        const r1 = visibleDots[1].getBoundingClientRect();
        dotStep = r1.left - r0.left;
      }

      const dotsRect      = this._dots.getBoundingClientRect();
      const activeDotRect = activeDot.getBoundingClientRect();

      const activeDotCenter     = activeDotRect.left + activeDotRect.width / 2;
      const dotsContainerCenter = dotsRect.left + dotsRect.width / 2;

      const offset = activeDotCenter - dotsContainerCenter;

      if (Math.abs(offset) > dotStep * 0.5) {
        this._dots.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }
    }

    // ─────────────────────────────────────────────
    // Navigate to slide
    // ─────────────────────────────────────────────
    goTo(n) {
      this._current = Math.max(0, Math.min(this._total - 1, n));
      this._track.style.transform = `translateX(-${this._current * 100}%)`;
      this._updateDots(this._current);
      this._updateSlideAccessibility(this._current);

      // Re-enable the smooth transition (it was disabled during drag)
      // then snap the bar exactly to the settled slide.
      this._progressFill?.classList.remove('no-transition');
      this._updateProgressBar(this._current);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this._scrollDotsToActive(this._current);
        });
      });

      this._arrowL.classList.remove('disabled');
      this._arrowR.classList.remove('disabled');
      this._arrowL.style.visibility = 'visible';
      this._arrowL.style.pointerEvents = 'auto';
      this._arrowR.style.visibility = 'visible';
      this._arrowR.style.pointerEvents = 'auto';
    }

    // ─────────────────────────────────────────────
    // Shared helper: turn a live drag offset (px) into
    // a fractional slide position and paint the bar with it.
    // This is what makes the bar behave like a real scrollbar —
    // it tracks the pointer 1:1 instead of waiting for release.
    // ─────────────────────────────────────────────
    _updateProgressBarLive(diffPx) {
      const trackWidth = this._track.offsetWidth || 1;
      const liveCurrent = this._current - (diffPx / trackWidth);
      this._updateProgressBar(liveCurrent);
    }

    // ─────────────────────────────────────────────
    // Desktop drag
    // ─────────────────────────────────────────────
    DesktopEvents(signal) {
      this._track.addEventListener('mousedown', e => {
        this._dragStart = e.clientX;
        this._dragging  = false;
      }, { signal });

      window.addEventListener('mousemove', e => {
        if (this._dragStart === null) return;
        this._dragCurrent = e.clientX;
        const diff = this._dragCurrent - this._dragStart;
        if (Math.abs(diff) > this._dragThreshold) {
          this._dragging = true;
          this._track.classList.add('dragging');
          this._progressFill?.classList.add('no-transition');
          this._track.style.transform = `translateX(calc(-${this._current * 100}% + ${diff}px))`;
          this._updateProgressBarLive(diff);
        }
      }, { signal });

      this._track.addEventListener('mouseup', () => {
        if (!this._dragging) { this._dragStart = null; return; }

        const diff = (this._dragCurrent || 0) - (this._dragStart || 0);
        this._track.classList.remove('dragging');

        // Only block the click that follows if the swipe actually crossed
        // the slide-change threshold. Small jitter behaves like a normal tap.
        if (diff < -50) {
          this._suppressClick = true;
          this.next();
        } else if (diff > 50) {
          this._suppressClick = true;
          this.prev();
        } else {
          this.goTo(this._current); // no real navigation — click stays allowed
        }

        this._dragStart   = null;
        this._dragCurrent = null;
        this._dragging    = false;
      }, { signal });
    }

    // ─────────────────────────────────────────────
    // Mobile touch
    // ─────────────────────────────────────────────
    MobileEvents(signal) {
      this._track.addEventListener('touchstart', e => {
        this._dragStart = e.touches[0].clientX;
        this._dragging  = false;
      }, { passive: true, signal });

      this._track.addEventListener('touchmove', e => {
        this._dragCurrent = e.touches[0].clientX;
        const diff = this._dragCurrent - this._dragStart;
        if (Math.abs(diff) > this._dragThreshold) {
          this._dragging = true;
          this._track.classList.add('dragging');
          this._progressFill?.classList.add('no-transition');
          this._track.style.transform = `translateX(calc(-${this._current * 100}% + ${diff}px))`;
          this._updateProgressBarLive(diff);
        }
      }, { passive: true, signal });

      this._track.addEventListener('touchend', () => {
        if (!this._dragging) {
          // Plain tap — let the browser's click/navigation happen normally
          this._dragStart   = null;
          this._dragCurrent = null;
          return;
        }

        const diff = (this._dragCurrent || 0) - (this._dragStart || 0);
        this._track.classList.remove('dragging');

        // Only block the click that follows if the swipe actually crossed
        // the slide-change threshold. Small jitter behaves like a normal tap.
        if (diff < -50) {
          this._suppressClick = true;
          this.next();
        } else if (diff > 50) {
          this._suppressClick = true;
          this.prev();
        } else {
          this.goTo(this._current);
        }

        this._dragStart   = null;
        this._dragCurrent = null;
        this._dragging    = false;
      }, { signal });
    }

    // ─────────────────────────────────────────────
    // Keyboard
    // ─────────────────────────────────────────────
    keydownEvents(signal) {
      document.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  this.prev();
        if (e.key === 'ArrowRight') this.next();
      }, { signal });
    }

    init() {
      this.goTo(0);
    }
  }

  customElements.define('custom-images-gallery', ImagesSlide);
})();

